import { cleanupInputValidations, setupAllValidations, validateLogicalGroup } from "@/utils/tour-guide-validation";
import { Config, DriveStep, Driver, State, driver } from "driver.js";
interface CustomDriveStep extends DriveStep {
  enableCTA?: boolean;  // Add your custom property
  stepId?: string;
  stepPath?: string;
  eventName?: string;
  beforeLeave?: any;
  checkElement?: boolean;
  checkRedirection?: boolean;
  disableActiveInteraction?: boolean;
  checkStatus?: boolean;
  isNavigatingBack?: boolean
  categoryId?: string;
  categoryName?: string
  locationId?: string
  productId?: string
  productName?: string
  inputValidations?: any
  stagePadding?: number
  _id?: string
  index?: number
}

const LEADGEN_LAUNCHPAD_TOUR_GUIDE_EVENT = 'leadgen-launchpad-tourguide-event'

function getCurrentStep(config?: Config, state?: State) {
  const subtractSteps = config?.steps
    ?.slice(0, state?.activeIndex)
    .filter(step => !('element' in step) || step?.element === undefined).length
  return (state?.activeIndex ?? 0) + 1 - (subtractSteps ?? 0)
}

// Adding this to properly destroy driver and handle back button
const handlePopState = () => {
  try {

    if (!window['driver']) return
    const activeIndex = window['driver'].getActiveIndex()
    const steps: CustomDriveStep[] = window['driver'].getConfig().steps

    // 1. we have to set isNavigatingBack to true when the step is supposed to navigate back - in stepData
    // 2. if its NavigatingBack then we set a value in sessionStorage to track if we are navigating back by setting it to true on NextClick

    // So if back is pressed, we check if the current step is navigating back and if it is, we check if the sessionStorage item is set to true
    // if session value is not true, we destroy the driver

    if (
      activeIndex === undefined ||
      !steps[activeIndex].isNavigatingBack ||
      (steps[activeIndex].isNavigatingBack &&
        sessionStorage.getItem('isDriverNavigating') !== 'true')
    ) {
      // console.log('testing::: destroying tour-guide membership')

      window['reason'] = 'navigation'
      window['message'] = 'tour-guide destroyed due to navigation'
      window['driver'].destroy()
      window['driver'] = null
      window.removeEventListener('popstate', handlePopState)
      sessionStorage.removeItem('isDriverNavigating')

      // console.log('testing::: destroyed tour-guide done membership')
    }
  } catch (err) {
    console.error('Failed to handle popstate:', err)
  }
}

// Add a function to setup popstate listener
function setupDriverPopstateListener() {
  try {
    // Remove existing listener if any
    window.removeEventListener('popstate', handlePopState)
    // Add new listener
    window.addEventListener('popstate', handlePopState)
  } catch (err) {
    console.error('Failed to setup driver popstate listener:', err)
  }
}

export async function startDriverGuide(model, parent, router) {
  try {
    if (model.currentTourStep < 0 || !model.tourSteps) {
      // console.log('No tour steps found: ', model.currentTourStep)
      return
    }
    setupDriverPopstateListener()

    if (parent && typeof parent.then === 'function' && !parent.emit) {
      parent = await parent
    }

    const driverObj = driver({
      allowClose: false,
      allowKeyboardControl: false,
      popoverClass: 'driverjs-theme',
      disableActiveInteraction: true,
      overlayColor: '#101828',
      overlayOpacity: 0.45,
      stagePadding: 6,
      popoverOffset: 6,
      onHighlightStarted: async (element, step: CustomDriveStep, opts) => {
        try {
          sessionStorage.removeItem('isDriverNavigating');

          if (step.enableCTA) {
            opts.driver.setConfig({
              ...opts.driver.getConfig(),
              disableActiveInteraction: false,
            })
            // Make the overlay pass through events to highlighted element
            const overlay = document.querySelector('.driver-overlay')
            if (overlay instanceof HTMLElement) {
              overlay.style.pointerEvents = 'none'
            }

            // Ensure highlighted element can receive events
            if (element instanceof HTMLElement) {
              element.style.pointerEvents = 'auto'
              element.style.position = 'relative'
              element.style.zIndex = '0'

              // Execute beforeLeave if it exists
              if (step.beforeLeave) {
                try {
                  // const functionBody = step.beforeLeave
                  //   .replace(/"use strict";/, '')
                  //   .trim()
                  //   .replace(/^\((.*?)\)\s*=>/, 'return ($1) =>')
                  //   .replace(/^function\s*\((.*?)\)/, 'return function($1)')

                  // const beforeLeaveFunction = new Function(
                  //   'element',
                  //   'step',
                  //   'opts',
                  //   functionBody
                  // )
                  // await step.beforeLeave(element, step, opts)(
                  //   element,
                  //   step,
                  //   opts
                  // )
                } catch (err) {
                  console.error('Failed to execute beforeLeave function:', err)
                }
              }

              element.addEventListener('click', () => {
                if (step.isNavigatingBack) {
                  sessionStorage.setItem('isDriverNavigating', 'true')
                }
                setTimeout(() => {
                  const activeStepIndex = (opts?.driver?.getActiveIndex() || 0) + 1
                  // localStorage.setItem('activeStepIndex', activeStepIndex.toString())
                  driverObj.moveNext()
                }, 500)
              })
            }
          } else {
            opts.driver.setConfig({
              ...opts.driver.getConfig(),
              disableActiveInteraction: true,
            })
          }

          if (step.inputValidations) {
            setupAllValidations(step.inputValidations)
          }

          if (step.stagePadding !== undefined) {
            opts.driver.setConfig({
              ...opts.driver.getConfig(),
              stagePadding: step.stagePadding,
            })
          }

          if ('disableActiveInteraction' in step) {
            opts.driver.setConfig({
              ...opts.driver.getConfig(),
              disableActiveInteraction: step.disableActiveInteraction,
            })
          }
        } catch (err) {
          console.error('Failed to handle highlight started:', err)
        }
      },
      onHighlighted: (element, step: CustomDriveStep, opts: { config: Config; state: State; driver: Driver }) => {
        try {
          if (step.popover?.title) {
            const currentStepOrder = getCurrentStep(opts.config, opts.state)
            parent.emit('tour-guide-track-pendo-event', {
              eventName: LEADGEN_LAUNCHPAD_TOUR_GUIDE_EVENT,
              eventProperties: {
                categoryId: step.categoryId,
                categoryName: step.categoryName,
                locationId: step.locationId,
                productId: step.productId,
                productName: step.productName,
                name: step.popover.title,
                stepId: step._id,
                type: currentStepOrder === 1 ? 'start' : opts.driver.isLastStep() ? 'completion' : '',
                reason: opts.driver.isLastStep() ? 'completion' : '',
                message: opts.driver.isLastStep() ? 'Tour guide completed' : '',
                timestamp: new Date().toISOString(),
                orderId: currentStepOrder
              }
            })
          }
        } catch (err) {
          console.error('Failed to handle highlighted:', err)
        }
      },
      onDeselected: (element, step: CustomDriveStep, opts) => {
        try {
          // return
          // Restore overlay's default behavior
          const overlay = document.querySelector('.driver-overlay')
          if (overlay instanceof HTMLElement) {
            overlay.style.pointerEvents = 'auto'
          }

          // Reset element styles
          if (element instanceof HTMLElement) {
            element.style.pointerEvents = ''
            element.style.position = ''
            element.style.zIndex = ''
          }

          opts.driver.setConfig({
            ...opts.driver.getConfig(),
            stagePadding: 6, // Reset stage padding
            popoverOffset: 6, // Reset popover offset
          })
        } catch (err) {
          console.error('Failed to handle deselected:', err)
        }
      },
      onPopoverRender: async (popover, { config, state, driver }) => {
        try {
          sessionStorage.removeItem('isDriverNavigating');
          if (popover.title.textContent === 'Popover Title') {
            let overlay = document.querySelector('.driver-overlay') as HTMLElement

            let popoverElem = document.querySelector(
              '.driver-popover'
            ) as HTMLElement

            if (overlay) overlay.style.display = 'none'
            if (popoverElem) popoverElem.style.display = 'none'
            // popover.wrapper.style.display = 'none'

            const MAX_TIME = 10_000
            let counter = 0
            await new Promise(resolve => {
              const timerId = setInterval(() => {
                // console.log('timer is being triggered: ', timerId)
                counter += 200
                if (counter >= MAX_TIME) {
                  clearInterval(timerId)
                  window['reason'] = 'timeout'
                  window['message'] = 'tour-guide destroyed due to timeout'
                  driver.destroy()
                  resolve(true)
                }

                if (!overlay) {
                  overlay = document.querySelector(
                    '.driver-overlay'
                  ) as HTMLElement
                }
                if (!popoverElem) {
                  popoverElem = document.querySelector(
                    '.driver-popover'
                  ) as HTMLElement
                }
                // @ts-expect-error: element is not defined
                const elem = document.querySelector(config.steps[state.activeIndex + 1].element)
                if (elem) {
                  // setTimeout(() => {
                  if (overlay) overlay.style.display = 'block'
                  if (popoverElem) popoverElem.style.display = 'block'
                  clearInterval(timerId)
                  // console.log('timer is being cleared')
                  resolve(true)
                  // }, 500)
                } else {
                  if (overlay) overlay.style.display = 'none'
                  if (popoverElem) popoverElem.style.display = 'none'
                }
              }, 1000)
            })

            // const activeStepIndex = (driver.getActiveIndex() || 0) + 1
            // localStorage.setItem('activeStepIndex', activeStepIndex.toString())
            driver.moveNext()
            return
          }

          const activeIndex = state?.activeIndex || null
          if (activeIndex !== null && config?.steps) {
            const step = (config.steps[activeIndex] as CustomDriveStep) || null
            if (step && 'beforeEnter' in step) {
              const opts = { config, state, driver }
              if (typeof step.beforeEnter === 'function') {
                await step.beforeEnter(
                  state.activeElement as Element,
                  step as CustomDriveStep,
                  opts
                )(state.activeElement as Element, step as CustomDriveStep, opts)
              }
            }
          }

          // Add progress bar after title
          createProgressBar(state, config)

          // Footer buttons
          createFooterButtons({ popover, driverObj, state, config })
        } catch (err) {
          console.error('Failed to handle popover render:', err)
        }
      },
      onDestroyStarted: (
        element?: Element,
        step?: CustomDriveStep,
        opts?: { config: Config; state: State; driver: Driver }
      ) => {
        try {
          parent.emit('launchpad-drawer-visibility-changed-spm-ts', {
            locationId: step?.locationId,
            isVisible: true
          })

          // This will be called when the tour is about to be destroyed (including when close button is clicked)
          if (opts?.driver?.isLastStep()) {
            const customStep = opts?.config?.steps?.find((step: CustomDriveStep) => step.checkStatus === true) as CustomDriveStep
            // console.log('::LS:: customStep', customStep)
            // log epoch timestamp
            console.log('::LS:: epoch timestamp emit', new Date(Date.now()))
            parent.emit('CHECK_DRAWER_VISIBILITY_SPM_TS', {
              eventName: customStep.eventName
            })
          } else {
            parent.emit(
              'destroy-tour-guide',
              getCurrentStep(opts?.config, opts?.state)
            )
            parent.emit('tour-guide-track-pendo-event', {
              eventName: LEADGEN_LAUNCHPAD_TOUR_GUIDE_EVENT,
              eventProperties: {
                categoryId: step?.categoryId,
                categoryName: step?.categoryName,
                locationId: step?.locationId,
                productId: step?.productId,
                productName: step?.productName,
                stepName: step?.popover?.title,
                stepId: step?._id,
                type: 'destroyed',
                reason: 'manual',
                message: 'Close button clicked',
                timestamp: new Date().toISOString(),
                orderId: getCurrentStep(opts?.config, opts?.state)
              }
            })
          }
          document.querySelectorAll('.driver-active .driver-overlay, .driver-active *')
            .forEach(el => {
              // @ts-expect-error: el is not defined
              el?.style?.removeProperty('pointer-events');
            });
          opts?.driver.destroy()
        } catch (err) {
          console.error('Failed to handle destroy started:', err)
        }
      },
      onDestroyed: (element, step: CustomDriveStep, opts: { config: Config; state: State; driver: Driver }) => {
        console.log('::LS:: tour-guide destroyed')
        if (window['reason']) {
          const activeIndex = opts?.config?.steps?.findIndex(
            (arrStep: CustomDriveStep) => {
              return arrStep.index == step.index
            }
          ) ?? 0
          const nextStep = opts?.config?.steps?.[activeIndex + 1] as CustomDriveStep
          parent.emit('tour-guide-track-pendo-event', {
            eventName: LEADGEN_LAUNCHPAD_TOUR_GUIDE_EVENT,
            eventProperties: {
              categoryId: step?.categoryId,
              categoryName: step?.categoryName,
              locationId: step?.locationId,
              productId: step?.productId,
              productName: step?.productName,
              stepName: step?.popover?.title || nextStep?.popover?.title || '',
              stepId: step?._id || nextStep?._id || '',
              type: 'destroyed',
              reason: window['reason'],
              message: window['message'],
              timestamp: new Date().toISOString(),
              orderId: getCurrentStep(opts.config, opts.state)
            }
          })
        }
      }
    })
    window['driver_frame'] = driverObj

    const tourSteps = JSON.parse(model.tourSteps)
    const steps: CustomDriveStep[] = createTourSteps({
      tourSteps,
      model,
      router,
      parent
    })

    // console.log(`Tour guide started with steps: ${tourSteps}`)

    driverObj.setSteps(steps as CustomDriveStep[])

    // const currentTourStep = Math.max(Number(localStorage.getItem('activeStepIndex') || 0), model.currentTourStep)
    // localStorage.setItem('activeStepIndex', currentTourStep.toString())
    driverObj.drive(model.currentTourStep)
  } catch (err) {
    console.log("Failed to start tour guide", err);
  }
}

function createTourSteps({ tourSteps, model, router, parent }) {
  try {
    const steps: CustomDriveStep[] = []

    tourSteps.map(tourStep => {
      if (tourStep.beforeLeave) {
        // Remove any "use strict" directives and convert to function
        const functionBody = tourStep.beforeLeave
          .replace(/"use strict";/, '')
          .trim()
          .replace(/^\((.*?)\)\s*=>/, 'return ($1) =>') // Convert arrow function syntax
          .replace(/^function\s*\((.*?)\)/, 'return function($1)') // Convert regular function syntax

        try {
          tourStep.beforeLeave = new Function(
            'element',
            'step',
            'opts',
            functionBody
          )
        } catch (err) {
          console.error('Failed to parse beforeLeave function:', err)
          // Provide a no-op function as fallback
          tourStep.beforeLeave = () => { }
        }
      }

      if (tourStep.beforeEnter) {
        // Remove any "use strict" directives and convert to function
        const functionBody = tourStep.beforeEnter
          .replace(/"use strict";/, '')
          .trim()
          .replace(/^\((.*?)\)\s*=>/, 'return ($1) =>') // Convert arrow function syntax
          .replace(/^function\s*\((.*?)\)/, 'return function($1)') // Convert regular function syntax

        try {
          tourStep.beforeEnter = new Function(
            'element',
            'step',
            'opts',
            functionBody
          )
        } catch (err) {
          console.error('Failed to parse beforeEnter function:', err)
          // Provide a no-op function as fallback
          tourStep.beforeEnter = () => { }
        }
      }
      // console.log('tourStep: ', tourStep)
      steps.push({
        ...tourStep,
        popover: {
          ...tourStep.popover,
          onNextClick: async (
            element: Element,
            step: CustomDriveStep,
            { config, state, driver }
          ) => {
            try {
              if (step.isNavigatingBack) {
                sessionStorage.setItem('isDriverNavigating', 'true')
              }

              if (step.inputValidations) {
                cleanupInputValidations(step.inputValidations)
              }

              const activeStepIndex = (driver.getActiveIndex() || 0) + 1
              // localStorage.setItem('activeStepIndex', activeStepIndex.toString())

              if (!driver.isLastStep()) {
                parent.emit('tour-guide-next-step', {
                  currentTourStep: activeStepIndex,
                })
              }

              if (
                // @ts-expect-error: stepPath is not defined
                step.stepPath !== config.steps[state.activeIndex + 1]?.stepPath &&
                step?.checkRedirection &&
                !driver.isLastStep()
              ) {
                // @ts-expect-error: stepPath is not defined
                let nextStepPath = config.steps[state.activeIndex + 1].stepPath

                nextStepPath = nextStepPath.replaceAll(
                  '{locationId}',
                  model.locationId
                )
                // nextStepPath = nextStepPath.replaceAll(
                //   '{funnelId}',
                //   model.funnelId
                // )
                // console.log('nextStepPath: ', nextStepPath)
                window['reason'] = 'navigation'
                window['message'] = 'Tour guide destroyed due to navigation'
                driver.destroy()
                router.push({ path: nextStepPath })
                return
              }

              if ('moveToParent' in step && step.moveToParent) {
                if (tourStep.beforeLeave) {
                  // console.log('tourStep.beforeLeave: ', tourStep.beforeLeave)
                  const opts = { config, state, driver }
                  await tourStep.beforeLeave(element, step, opts)(
                    element,
                    step,
                    opts
                  )
                  parent.emit('tour-guide-after-step-change', { currentTourStep: activeStepIndex })
                }
                return
              }

              if (tourStep.beforeLeave) {
                // console.log('tourStep.beforeLeave: ', tourStep.beforeLeave)
                const opts = { config, state, driver }
                await tourStep.beforeLeave(element, step, opts)(
                  element,
                  step,
                  opts
                )
              } else {
                driver.moveNext()
              }
            } catch (err) {
              console.error('Validation error:', err)
              return false
            }
          },
        },
      })
    })

    return steps
  } catch (err) {
    console.error('Failed to create tour steps:', err)
    return []
  }
}

function createProgressBar(state, config) {
  try {
    const progressBarContainer = document.createElement('div')
    progressBarContainer.classList.add('driver-progress-bar-container')
    progressBarContainer.style.margin = '10px 0'

    const progressBar = document.createElement('div')
    progressBar.classList.add('driver-progress-bar')
    progressBar.style.height = '16px'
    progressBar.style.backgroundColor = '#f1f1f1'
    progressBar.style.borderRadius = '8px'

    const progress = document.createElement('div')
    progress.classList.add('driver-progress')
    const subtractSteps = config.steps
      .slice(0, state.activeIndex)
      .filter(step => !('element' in step) || step?.element === undefined).length
    progress.style.width = `${((state.activeIndex + 1 - subtractSteps) /
      config.steps.filter(step => 'element' in step && step.element).length) *
      100
      }%`
    progress.style.height = '100%'
    progress.style.backgroundColor = '#155eef'
    progress.style.borderRadius = '8px'
    progress.style.transition = 'width 0.3s ease'

    const progressText = document.createElement('div')
    progressText.classList.add('driver-progress-text')
    progressText.style.textAlign = 'end'
    progressText.style.fontSize = '10px'
    progressText.style.fontWeight = '600'
    progressText.style.fontFamily = 'Inter'
    progressText.style.color = '#fff'
    progressText.style.paddingRight = '10px'
    progressText.textContent = `${state.activeIndex + 1 - subtractSteps}/${config.steps.filter(step => 'element' in step && step.element).length
      }`

    progress.appendChild(progressText)
    progressBar.appendChild(progress)
    progressBarContainer.appendChild(progressBar)

    // Insert progress bar after title
    const title = document.querySelector('.driver-popover-title')
    if (title) {
      title.parentNode?.insertBefore(progressBarContainer, title.nextSibling)
    }
  } catch (err) {
    console.error('Failed to create progress bar:', err)
  }
}

function createFooterButtons({ popover, driverObj, state, config }) {
  try {
    popover.footerButtons.innerHTML = ''

    // Create next button
    const nextButton = document.createElement('button')
    nextButton.innerText =
      state.activeIndex === config.steps.length - 1 ? 'Mark As Complete' : 'Next'
    nextButton.classList.add('driver-popover-next-btn')
    nextButton.style.position = 'relative';
    nextButton.style.overflow = 'hidden';

    // Create shimmer effect
    const shimmerWave = document.createElement('div');
    shimmerWave.classList.add('shimmer-wave');
    shimmerWave.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: calc(100% + ${state.activeIndex === config.steps.length - 1 ? '0px' : '25px'});
      transform: rotate(135deg);
      background: linear-gradient(
        40deg,
        transparent 0%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 100%
      );
      animation: shimmer 2s infinite;
      filter: drop-shadow(0 0 5px white);
      z-index: 0;
      pointer-events: none;
    `;

    // Add shimmer animation
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @keyframes shimmer {
        0% { transform: translateX(-100%) rotate(135deg); }
        100% { transform: translateX(100%) rotate(135deg); }
      }
    `;
    document.head.appendChild(styleSheet);

    // Add shimmer to button
    nextButton.appendChild(shimmerWave);

    const leftSideButtons = document.createElement('div')
    leftSideButtons.classList.add('flex')
    // leftSideButtons.appendChild(prevButton)

    const rightSideButtons = document.createElement('div')
    // rightSideButtons.appendChild(skipButton)
    rightSideButtons.appendChild(nextButton)

    const footerButtons = document.createElement('div')
    footerButtons.classList.add('flex', 'justify-between', 'w-full')
    footerButtons.appendChild(leftSideButtons)
    footerButtons.appendChild(rightSideButtons)

    popover.footerButtons.appendChild(footerButtons)
    updateNextButton({ step: config.steps[state.activeIndex] as CustomDriveStep })
  } catch (err) {
    console.error('Failed to create footer buttons:', err)
  }
}

export const updateNextButton = ({
  step,
  isValid,
}: {
  step?: CustomDriveStep
  isValid?: boolean
}) => {
  const nextButton = document.querySelector(
    '.driver-popover-next-btn'
  ) as HTMLButtonElement
  if (!nextButton) return

  let isValidInput = isValid
  if (isValid === undefined) {
    if (!step?.inputValidations) return
    isValidInput = validateLogicalGroup(
      step.inputValidations.logic,
      step.inputValidations.fields
    )
  }

  nextButton.disabled = !isValidInput
  nextButton.style.backgroundColor = isValidInput ? '#155eef' : '#fff'
  nextButton.style.border = isValidInput
    ? '2px solid #155eef'
    : '2px solid rgb(224, 224, 230)'
  nextButton.style.color = isValidInput ? '#fff' : 'rgba(52, 64, 84, 1)'
  nextButton.style.opacity = isValidInput ? '1' : '0.6'
  nextButton.style.cursor = isValidInput ? 'pointer' : 'not-allowed'
}